export default function setCookie (name, value) {
  if (name !== 'language' && !(localStorage.getItem('cookies_enabled') === '1')) return
  document.cookie = `${name} = ${value}`
}
